import React, { useState, useEffect } from "react";
import "../../index.css";

const Registration = () => {
    // --- ESTADOS PARA LOS DATOS ---
    const [curso, setCurso] = useState("");
    const [cursos, setCursos] = useState([]);
    
    // Estado para capturar los datos de los inputs de texto
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: ""
    });

    // --- ESTADOS DE CONTROL DE UI ---
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: "", text: "" });

    // --- CARGAR CURSOS DESDE EL BACKEND ---
    useEffect(() => {
        const fetchCursos = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOST_BACKEND}/programs/getAll`);

                if (!response.ok) {
                    throw new Error("Error al obtener los cursos");
                }

                const data = await response.json();
                setCursos(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCursos();
    }, []);

    // --- MANEJADOR DE CAMBIOS EN LOS INPUTS ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // --- MANEJADOR DE ENVÍO DEL FORMULARIO ---
    const handleSubmit = async (e) => {
        e.preventDefault(); // Evita que la página se recargue al enviar el formulario
        setIsSubmitting(true);
        setSubmitMessage({ type: "", text: "" }); // Resetea mensajes previos

        try {
            // Ajusta la ruta "/leads/register" según el endpoint exacto que tengas en tu backend
            const response = await fetch(`${process.env.REACT_APP_HOST_BACKEND}/leads/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    course_id: curso // ID del curso seleccionado
                }),
            });

            if (!response.ok) {
                throw new Error("Hubo un problema al procesar tu solicitud. Intenta nuevamente.");
            }

            // Muestra mensaje de éxito y limpia el formulario
            setSubmitMessage({ type: "success", text: "¡Registro exitoso! Te mantendremos informado." });
            setFormData({ name: "", email: "", phone: "" });
            setCurso("");

            // Opcional: Ocultar el mensaje de éxito después de unos segundos
            setTimeout(() => setSubmitMessage({ type: "", text: "" }), 5000);

        } catch (error) {
            setSubmitMessage({ type: "error", text: error.message });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {/* Registration Start */}
            <div className="container-fluid bg-registration py-5" style={{ margin: "90px 0" }}>
                <div className="container py-5">
                    <div className="row align-items-center">

                        {/* Copy izquierdo */}
                        <div className="col-lg-7 mb-5 mb-lg-0">
                            <div className="mb-4">
                                <h5
                                    className="text-primary text-uppercase mb-3"
                                    style={{ letterSpacing: "5px" }}
                                >
                                    Acceso anticipado
                                </h5>
                                <h1 className="text-white" style={{ lineHeight: "1.2" }}>
                                    Sé el primero en enterarte — y paga menos
                                </h1>
                            </div>

                            <p className="text-white mb-4" style={{ fontSize: "1.05rem", lineHeight: "1.8", opacity: 0.9 }}>
                                Cada nuevo curso que lanzamos tiene una ventana de preventa exclusiva para nuestra lista.
                                Si no estás en ella, simplemente pagas más — o te quedas sin cupo.
                            </p>

                            <ul className="list-unstyled text-white m-0">
                                <li className="d-flex align-items-start py-2">
                                    <i className="fa fa-check-circle text-primary mr-3 mt-1"></i>
                                    <span><strong>Precios de preventa</strong> — siempre los más bajos que existirán para ese curso.</span>
                                </li>
                                <li className="d-flex align-items-start py-2">
                                    <i className="fa fa-check-circle text-primary mr-3 mt-1"></i>
                                    <span><strong>Primero en saberlo</strong> — antes que el público general.</span>
                                </li>
                                <li className="d-flex align-items-start py-2">
                                    <i className="fa fa-check-circle text-primary mr-3 mt-1"></i>
                                    <span><strong>Sin spam</strong> — solo te escribimos cuando hay algo que vale la pena.</span>
                                </li>
                                <li className="d-flex align-items-start py-2">
                                    <i className="fa fa-check-circle text-primary mr-3 mt-1"></i>
                                    <span><strong>Cancela cuando quieras</strong> — sin compromisos.</span>
                                </li>
                            </ul>

                            {/* Prueba social pequeña */}
                            <div
                                className="mt-4 p-3 rounded d-inline-flex align-items-center"
                                style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }}
                            >
                                <i className="fa fa-users text-primary mr-3" style={{ fontSize: "1.4rem" }}></i>
                                <p className="text-white m-0" style={{ fontSize: "0.9rem", opacity: 0.85 }}>
                                    Más de <strong>200 personas</strong> ya reciben nuestras novedades antes que nadie.
                                </p>
                            </div>
                        </div>

                        {/* Formulario derecho */}
                        <div className="col-lg-5">
                            <div className="card border-0" style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
                                <div className="card-header bg-light text-center p-4">
                                    <h2 className="m-0 font-weight-bold" style={{ fontSize: "1.5rem" }}>
                                        Quiero obtener promociones
                                    </h2>
                                    <p className="text-muted m-0 mt-1" style={{ fontSize: "0.85rem" }}>
                                        Sin compromisos. En 30 segundos.
                                    </p>
                                </div>
                                <div className="card-body rounded-bottom bg-primary p-5">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                className="form-control border-0 p-4"
                                                placeholder="¿Cómo te llamas?"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                className="form-control border-0 p-4"
                                                placeholder="Tu email"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                className="form-control border-0 p-4"
                                                placeholder="WhatsApp con código de área"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <select
                                                className="custom-select border-0 px-4"
                                                style={{ height: "47px" }}
                                                value={curso}
                                                onChange={(e) => setCurso(e.target.value)}
                                                disabled={loading}
                                            >
                                                {loading && <option value="">Cargando cursos...</option>}
                                                {error && <option value="">Error al cargar cursos</option>}
                                                {!loading && !error && (
                                                    <>
                                                        <option value="">¿Qué quieres aprender?</option>
                                                        {cursos.map((c) => (
                                                            <option key={c.id} value={c.id}>
                                                                {c.title}
                                                            </option>
                                                        ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <button
                                                className="btn btn-dark btn-block border-0 py-3 font-weight-bold"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{ fontSize: "1rem", letterSpacing: "0.5px", borderRadius: "8px" }}
                                            >
                                                {isSubmitting ? "Enviando..." : "Quiero información de promociones →"}
                                            </button>
                                        </div>

                                        {/* Mensajes de feedback (Éxito o Error) */}
                                        {submitMessage.text && (
                                            <div className={`mt-3 text-center p-2 rounded ${submitMessage.type === 'success' ? 'bg-success text-white' : 'bg-danger text-white'}`} style={{ fontSize: "0.85rem" }}>
                                                {submitMessage.text}
                                            </div>
                                        )}

                                        <p className="text-white text-center mt-3 m-0" style={{ fontSize: "0.78rem", opacity: 0.7 }}>
                                            🔒 Tu información está segura. No compartimos tus datos con nadie.
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* Registration End */}
        </>
    );
};

export default Registration;